import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f6d8138"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Arbeidskosten", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Voor de werkzaamheden die MaatOntwikkeling verricht, worden arbeidskosten in rekening gebracht. Indien u wilt weten wat MaatOntwikkeling voor u kan betekenen, kijkt u op de "),
  /*#__PURE__*/_createElementVNode("a", { href: "werkzaamheden" }, "werkzaamheden"),
  /*#__PURE__*/_createTextVNode(" pagina. ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " De minimale afname van een afspraak bestaat uit een halfuur arbeidskosten. Indien een afspraak uw problemen niet heeft verholpen, wordt alleen de minimale afname in rekening gebracht. ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Voorrijkosten", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Indien u een afspraak op uw locatie wilt maken, brengt MaatOntwikkeling voorrijkosten in rekening. De hoogte van de voorrijkosten is afhankelijk van de afstand die moet worden afgelegd om op uw adres te arriveren. ", -1))
const _hoisted_7 = ["href"]
const _hoisted_8 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_layout = _resolveComponent("header-layout")!
  const _component_notice_alert = _resolveComponent("notice-alert")!
  const _component_single_block = _resolveComponent("single-block")!
  const _component_price_tag = _resolveComponent("price-tag")!
  const _component_triple_block = _resolveComponent("triple-block")!
  const _component_footer_layout = _resolveComponent("footer-layout")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_header_layout, {
      title: "Tarieven",
      displaySearchForm: false
    }),
    _createElementVNode("section", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_single_block, null, {
          default: _withCtx(() => [
            _createVNode(_component_notice_alert, null, {
              default: _withCtx(() => [
                _createTextVNode(" Alle tarieven zijn inclusief btw. ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _hoisted_3,
            _hoisted_4,
            _createVNode(_component_price_tag, {
              price: "€25,00",
              unit: "per kwartier"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6,
            _createElementVNode("p", null, [
              _createTextVNode(" De afstand betreft een enkele reis van MaatOntwikkeling naar uw adres. De berekening wordt gedaan met behulp van "),
              _createElementVNode("a", {
                href: $data.googleMapsUrl,
                target: "_blank"
              }, "Google Maps®", 8, _hoisted_7),
              _createTextVNode(". De afstand wordt altijd op gehele kilometers naar boven afgerond. ")
            ]),
            _createVNode(_component_price_tag, {
              price: "€2,50",
              unit: "per kilometer"
            })
          ]),
          _: 1
        }),
        _createVNode(_component_triple_block, null, {
          default: _withCtx(() => [
            _createElementVNode("img", { src: $data.tarievenImage }, null, 8, _hoisted_8)
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_footer_layout)
  ], 64))
}